import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Auth from '../../auth/auth';
import fingerPrint from '../../helpers/fingerprintjs';
import { AuthService } from '../../Services/authServices';
import toast from 'react-hot-toast';
import { ExamService } from '../../Services/examServices';
import { defaultTheme, TopBar, UserChip, NxIcon } from '../nx';

const t = defaultTheme;

export default function DashboardNav() {
    const navigate = useNavigate();
    const [profile, setProfile] = useState<any>();

    const getProfile = async () => {
        try {
            const res = await ExamService.getUserInfoWtihoutExams();
            if (res.status === 200) setProfile(res.data.data.studentInfo[0]);
        } catch (e) {}
    };

    const handleLogout = async () => {
        try {
            const res = await AuthService.logout({ devInfo: await fingerPrint() });
            if (res.status === 200) {
                await Auth.signout();
                localStorage.setItem("authKey", res.data.data.token);
                toast.success("Logged out");
            }
            navigate('/login');
        } catch (err) {
            navigate('/login');
        }
    };

    useEffect(() => { getProfile(); }, []);

    const profileName = profile ? `${profile.name || ''} ${profile.last_name || ''}`.trim() : 'User';

    return (
        <TopBar
            t={t}
            crumbs={['Dashboard']}
            right={<>
                <button
                    onClick={() => navigate('/exam/user/profile')}
                    style={{ width: 32, height: 32, borderRadius: 8, background: 'transparent', border: `1px solid ${t.border}`, color: t.inkSoft, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                >
                    {NxIcon.info(t.inkSoft)}
                </button>
                <UserChip t={t} name={profileName} email={profile?.email} onLogout={handleLogout} />
            </>}
        />
    );
}
